import { ICouponcodeState } from ".";
import * as actions from './actions';

const initialState: ICouponcodeState = {
    codeInfo: { id: '', codeType: undefined, details: "", plan: undefined }
}
export const couponCodeReducer = (state: ICouponcodeState = initialState, action) => {
    switch (action.type) {
        case actions.COUPON_VALIDATE_SUCCESS:
            return { ...state, codeInfo: action.codeInfo };
        case actions.COUPON_VALIDATE_FAIL:
        case actions.COUPON_VALIDATE_CANCEL:
        case actions.COUPON_REDEEM_SUCCESS:
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/couponcodes/reducer.ts